// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__32aQL","ranges":"BmiRanges_ranges__1cXpD"};